import { axiosClient } from '../http/axios-client';
import { IPrintGateway, PrintEntity } from '@gishub/domain';

export class PrintGateway implements IPrintGateway {
  async send(entity: PrintEntity): Promise<void> {
    const res = await axiosClient.post('/printer/export', entity, { responseType: 'blob' });

    const disposition = res.headers?.['content-disposition'] ?? '';
    const match = disposition.match(/filename="?(.+?)"?\s*(?:;|$)/);
    const filename = match?.[1] ?? 'mapa-exportado.pdf';

    const url = URL.createObjectURL(res.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }
}
